import { pickBy, size } from "lodash";

export default (obj: Record<string, unknown>): number => {
  if (!obj || typeof obj !== "object") {
    return 0;
  }

  return size(pickBy(obj, (value) => value !== null));
};
